import React from "react";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";
import { useProductsContext } from "../context/products_context";
import { FaTimes, FaChevronRight, FaShoppingCart } from "react-icons/fa";
import { links } from "../utils/constants";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { useCartContext } from "../context/cart_context";

const Sidebar = () => {
  const { isSidebarOpen, closeSidebar } = useProductsContext();
  const { total_items } = useCartContext();

  return (
    <AnimatePresence>
      {isSidebarOpen && (
        <SidebarContainer>
          <motion.div
            className="backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.22 }}
            onClick={closeSidebar}
          />
          <motion.aside
            className="drawer"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "tween", ease: [0.4, 0, 0.2, 1], duration: 0.32 }}
            role="dialog"
            aria-label="Menu"
          >
            <div className="drawer-header">
              <img src={logo} alt="Bushman Bar Service" className="logo" />
              <button
                className="close-btn"
                type="button"
                onClick={closeSidebar}
                aria-label="Zavřít menu"
              >
                <FaTimes />
              </button>
            </div>

            <ul className="links">
              {links.map(({ id, text, url }) => (
                <li key={id}>
                  <Link to={url} onClick={closeSidebar}>
                    <span>{text}</span>
                    <FaChevronRight className="chev" />
                  </Link>
                </li>
              ))}
            </ul>

            <Link
              to="/cart"
              className="cart-cta"
              onClick={closeSidebar}
            >
              <FaShoppingCart />
              <span>Košík</span>
              <span className="badge">{total_items}</span>
            </Link>
          </motion.aside>
        </SidebarContainer>
      )}
    </AnimatePresence>
  );
};

const SidebarContainer = styled.div`
  .backdrop {
    position: fixed;
    inset: 0;
    background: rgba(15, 10, 6, 0.55);
    backdrop-filter: blur(2px);
    z-index: 998;
  }
  .drawer {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    width: min(85vw, 340px);
    background: var(--clr-cream);
    z-index: 999;
    display: flex;
    flex-direction: column;
    box-shadow: var(--shadow-lg);
  }
  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.5rem;
    background: var(--clr-dark-1);
    flex-shrink: 0;
  }
  .logo {
    height: 48px;
    width: auto;
  }
  .close-btn {
    font-size: 1.5rem;
    background: transparent;
    border: none;
    color: var(--clr-cream);
    cursor: pointer;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius);
    transition: var(--transition);
    &:hover {
      background: rgba(255, 255, 255, 0.08);
    }
  }
  .links {
    list-style: none;
    flex: 1;
    overflow-y: auto;
    padding: 0.5rem 0;
  }
  .links li + li {
    border-top: 1px solid var(--clr-divider);
  }
  .links a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 56px;
    padding: 0 1.5rem;
    color: var(--clr-charcoal-1);
    font-family: var(--ff-display);
    font-size: 1.15rem;
    font-weight: 500;
    text-transform: capitalize;
    transition: var(--transition);
  }
  .links a:hover {
    background: var(--clr-cream-warm);
    color: var(--clr-accent-dark);
    padding-left: 1.75rem;
  }
  .chev {
    color: var(--clr-charcoal-3);
    font-size: 0.85rem;
  }
  .cart-cta {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    background: var(--clr-accent);
    color: var(--clr-paper);
    padding: 1.1rem 1.5rem;
    font-family: var(--ff-body);
    font-weight: 600;
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    flex-shrink: 0;
    transition: var(--transition);
    svg {
      font-size: 1.2rem;
    }
    .badge {
      background: var(--clr-paper);
      color: var(--clr-accent-dark);
      min-width: 28px;
      height: 28px;
      border-radius: 999px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 0.85rem;
      padding: 0 0.5rem;
    }
    &:hover {
      background: var(--clr-accent-dark);
    }
  }
  @media screen and (min-width: 992px) {
    display: none;
  }
`;

export default Sidebar;
